import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import Switch from "@material-ui/core/Switch";


const styles = theme => ({
	image: {
		height: "40px",
		width: "auto",
	},
	switch: {
		'user-select': 'none',
		'cursor': 'pointer',
	}
});

function SettingsOptionSwitch(props) {
	const { name, img, classes, isLast, state, onClick } = props;
	// console.log(props);
	return (
		<div>
			<ListItem
				button={true}
				onClick={() => onClick(!state)}
				className={classes.switch}
			>
				<img className={classes.image} src={img} alt={name} />
				<ListItemText primary={name} style={{padding: "0 16px"}}/>
				<Switch checked={state} color="primary" />
			</ListItem>
			{isLast || <Divider variant="inset" />}
		</div>
	);
}

SettingsOptionSwitch.propTypes = {
	name: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	isLast: PropTypes.bool,

	classes: PropTypes.shape({
		image: PropTypes.string.isRequired,
		switch: PropTypes.string.isRequired,
	}).isRequired,

	onClick: PropTypes.func,
};

export default withStyles(styles)(SettingsOptionSwitch);
